import { useMicVAD } from "@ricky0123/vad-react"
import useExternalApiService from "../../../helpers/ExternalApiService";
import SpeechAnimation from "../Animation/SpeechAnimation";
import React from "react";

interface ISpeech2Text {
    handleSubmit: (text: string) => void;
    setLoading: (loading: boolean) => void;
}

const Speech2Text: React.FC<ISpeech2Text> = ({handleSubmit, setLoading}) => {
    const { postDataWithFormData } = useExternalApiService(process.env.REACT_APP_EAI_URL);

    const vad = useMicVAD({
        onSpeechEnd: async (audio: Float32Array) => {
            // Convert Float32Array to WAV format
            const audioData = new Float32Array(audio);
            const wavBuffer = new ArrayBuffer(44 + audioData.length * 2);
            const view = new DataView(wavBuffer);

            // Write WAV header
            const writeString = (view: DataView, offset: number, string: string) => {
                for (let i = 0; i < string.length; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            };

            writeString(view, 0, 'RIFF');
            view.setUint32(4, 32 + audioData.length * 2, true);
            writeString(view, 8, 'WAVE');
            writeString(view, 12, 'fmt ');
            view.setUint32(16, 16, true);
            view.setUint16(20, 1, true);
            view.setUint16(22, 1, true);
            view.setUint32(24, 16000, true);
            view.setUint32(28, 32000, true);
            view.setUint16(32, 2, true);
            view.setUint16(34, 16, true);
            writeString(view, 36, 'data');
            view.setUint32(40, audioData.length * 2, true);

            // Write audio data
            for (let i = 0; i < audioData.length; i++) {
                const s = Math.max(-1, Math.min(1, audioData[i]));
                view.setInt16(44 + i * 2, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }

            // Create Blob and download
            const blob = new Blob([wavBuffer], { type: 'audio/wav' });

            const formData = new FormData();
            // Create a new FormData object
            formData.append('audio', blob);

            setLoading(true);
            const response = await postDataWithFormData('/api/e/winback_speech_to_text', formData);

            handleSubmit(response.transcription);
        },
    })

    return (
        <SpeechAnimation vad={vad.userSpeaking}/>
    );
}

export default Speech2Text;
